import React, { Component } from 'react'
import Container from '../common/application_container'
import AccountTable from './accountTable';


export class Accounts extends Component {
    render() {
        return (
            <Container title="Accounts" title1="Section" icon="fa fa-user">
                <AccountTable />
            </Container>
        )
    }
}

export default Accounts
